import { render, staticRenderFns } from "./HeaderSearch.vue?vue&type=template&id=37c343e8&scoped=true&"
import script from "./HeaderSearch.vue?vue&type=script&lang=js&"
export * from "./HeaderSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c343e8",
  null
  
)

export default component.exports